import React from "react";
import { cn } from "@/lib/utils";

// "OG" early-member badge, toggled by Owner/Admin. Sits next to the verified check.
export function OgBadge({ size = 15, className }) {
  return (
    <span data-testid="og-badge" title="OG — early AuraMax member" className={cn("inline-flex shrink-0 items-center justify-center rounded-md aura-gradient font-mark font-extrabold leading-none text-black", className)} style={{ height: size, minWidth: size * 1.5, fontSize: Math.max(8, size * 0.6), padding: `0 ${size * 0.25}px` }}>
      OG
    </span>
  );
}
